import { useState, useEffect } from "react";

import {
	scroll,
	API_URL,
	translate,
	fmtCurrency,
	createMarkup,
} from "../../utils";
import useFetch from "../../utils/useFetch";

import Alert from "../../components/Alert";

const Receipt = ({ id, lang }) => {
	const [url, setUrl] = useState(null);
	const [details, setDetails] = useState({});

	const { loading, data } = useFetch(url);

	useEffect(() => {
		scroll();
		const newUrl = new URL(`${API_URL}/cmReceiptInit`);
		const params = {
			id,
			lang,
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setDetails({
				...data,
			});
		}
	}, [data]);

	return (
		<>
			{loading ? (
				<Alert
					data={{
						type: "working",
						text: "",
					}}
				/>
			) : (
				<>
					<div className="match-play-container">
						<div>
							<div
								className="receipt"
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
							>
								<i className="fa fa-check-circle fa-3x" />
								<div className="subhead">
									{translate(
										lang,
										`Gracias por enviar tu cuota de inscripción para el Clasificatorio Mexicano presentado por National Car Rental. Recibirás más información sobre tu participación una vez cerrado el proceso de inscripción.`,
										`Gracias por enviar tu cuota de inscripción para el Clasificatorio Mexicano presentado por National Car Rental. Recibirás más información sobre tu participación una vez cerrado el proceso de inscripción.`
									)}
								</div>
							</div>

							<div className="spacer-25"> </div>

							<p
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
								dangerouslySetInnerHTML={createMarkup(
									translate(
										lang,
										`Para cualquier inquietud por favor contáctanos a esta dirección <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`,
										`Para cualquier inquietud por favor contáctanos a esta dirección <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`
									)
								)}
							/>

							<div className="spacer-25"> </div>

							<p
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
								dangerouslySetInnerHTML={createMarkup(
									translate(
										lang,
										`En caso de necesitar factura favor solicitarla a <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`,
										`En caso de necesitar factura favor solicitarla a <a href="mailto:cramos@wwtchampionship.com">cramos@wwtchampionship.com</a>.`
									)
								)}
							/>

							<div className="spacer-25"> </div>

							<p
								style={{
									fontSize: "0.95rem",
									lineHeight: "22px",
								}}
								dangerouslySetInnerHTML={createMarkup(
									translate(
										lang,
										`Todas las ventas son finales. No se permiten devoluciones, cambios o posponer para otra ocasión. En caso de hacer WD, se te cobrará un cargo de cancelación de $800 MXN. Al recibir esta confirmación, aceptaste las condiciones de compra.`,
										`Todas las ventas son finales. No se permiten devoluciones, cambios o posponer para otra ocasión. En caso de hacer WD, se te cobrará un cargo de cancelación de $800 MXN. Al recibir esta confirmación, aceptaste las condiciones de compra.`
									)
								)}
							/>
						</div>
					</div>
					<table>
						<thead>
							<tr>
								<th> {translate(lang, `Cantidad`, `Cantidad`)} </th>
								<th className="left">
									{translate(lang, `Descripción`, `Descripción`)}
								</th>
								<th> {translate(lang, `Precio`, `Precio`)} </th>
								<th> {translate(lang, `Total`, `Total`)} </th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="center"> {details.items[0].qty} </td>
								<td>
									<b>{details.items[0].name}</b>
									<p
										style={{
											marginTop: "5px",
											lineHeight: "21px",
										}}
									>
										<small>
											{details.items[0].participant} <br />
											{details.items[0].contact}
										</small>
									</p>
								</td>
								<td className="right">
									{fmtCurrency(details.items[0].price / 100)}
								</td>
								<td className="right"> {details.items[0].total} </td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<th colSpan="3" className="right">
									{translate(lang, `TOTAL`, `TOTAL`)}
								</th>
								<th className="right"> {details.total} </th>
							</tr>
							<tr>
								<td colSpan="3" className="right">
									{details.payment.descr}
								</td>
								<td className="right"> {details.payment.amt} </td>
							</tr>
						</tfoot>
					</table>
				</>
			)}
		</>
	);
};

export default Receipt;
